import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK, TRACK_STATE_STATUS } from "../../../config/constants";

const Track5HBlack = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK);
	return (
		<g id="Track5HBlack" transform="translate(1628.000000, 372.000000)" className="track">
			<g id="line" transform="translate(0.000000, 0.286950)" strokeLinecap="round">
				<path
					d="M205.263035,14.2682179 C196.317105,6.24131084 182.765222,6.22804 173.803588,14.2374108 L172.065375,15.7909211 L172.065375,15.7909211"
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
					strokeWidth={tracksWidth}
				/>

				<polyline
					id="arrow"
					strokeWidth={arrowWidth}
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
					strokeLinejoin="round"
					transform="translate(173.931347, 14.071701) rotate(-40.000000) translate(-173.931347, -14.071701) "
					points="177.931347 22.0717012 169.931347 14.0717012 177.931347 6.07170122"
				/>

        <path
          d="M163.459973,23.3368867 L120.968041,61.3136279 L79.5323223,68.5672409 C49.6735841,73.7942221 23.7974474,92.282804 9.17673623,118.83653 C4.61651203,127.118682 1.563683,132.912597 0.0182491411,136.218275"
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
					strokeWidth={tracksWidth}
				/>

				{/*<path*/}
				{/*	d="M345.798677,22.5654733 L297.968041,65.3136279 L248.548979,73.2769656 C226.065581,76.8999176 206.673537,91.0631849 196.381485,111.378268 L193.85046,116.374162 C184.824016,134.191111 170.669074,148.896898 153.209539,158.59664 L37.9931722,222.605732 C16.3937937,234.605387 7.33538364,260.972776 17,283.71305 L17,283.71305 L17,283.71305"*/}
				{/*	stroke={state === TRACK_STATE_STATUS ? trackColor : "url(#linearGradient-5)"}*/}
				{/*	strokeWidth={tracksWidth}*/}
				{/*/>*/}
			</g>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track5HBlack')}
				coords="115.762970, 34.600578"
				text="5H"
				textCoordsX="9.77392578"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			/>
		</g>
	)
};

Track5HBlack.propTypes = trackPropTypes;

export default Track5HBlack;
